<style src="./style.scss">
</style>

<script>
  import Icon from "svelte-icon";
  import CheckedIcon from "@assets/icons/checked.svg";
  export let active = null;
  export let checked = -1;
  export let indexes = [];
</script>

<div class="steps">
  {#each indexes as item, index}
    <div
      class="{`steps__item ${active === index ? 'active' : ''} ${
        checked >= index ? 'checked' : ''
      } `}">
      {#if checked >= index}
        <div class="checked__icon">
          <Icon data="{CheckedIcon}" stroke="transparent" fill="transparent" />
        </div>
      {:else}
        {item}
      {/if}
    </div>
  {/each}
</div>
